const RadioGroup = ({ label, name, options, value, onChange, required = false, error }) => (
    <div className="flex flex-col gap-1">
        <label className="block text-sm font-medium text-gray-700">
            {label} {required && <span className="text-red-500">*</span>}
        </label>
        <div className="mt-1 flex flex-wrap gap-x-4 gap-y-2">
            {options.map((option) => (
                <div key={option.value} className="flex items-center">
                    <input
                        type="radio"
                        id={`${name}-${option.value}`}
                        name={name}
                        value={option.value}
                        checked={value === option.value}
                        onChange={onChange}
                        className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300"
                    />
                    <label htmlFor={`${name}-${option.value}`} className="ml-2 block text-sm text-gray-900">
                        {option.label}
                    </label>
                </div>
            ))}
        </div>
        {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
);

export default RadioGroup;